import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import { IExpedition, IAskAppointment, IExpeditionNotification } from "@/models";

@Component({
    name: "NotificationAskExpedition",
})

export default class NotificationAskExpedition extends Vue {
    @Prop({ required: true })
    public notification: IExpeditionNotification;

    constructor() {
        super();
    }

    public get waitingFor(): string {
        const waiting = this.$store.state.app.now.getTime() - new Date(this.notification.askAppointment.startTime).getTime();
        return `${waiting > 0 ? Math.round(waiting / 1000 / 60) : 0} min`;
    }

    @Emit("showExpeditionInit")
    public setSelectedNotification(): void {
        this.$store.dispatch("expeditions/setSelectedNotification", this.notification);
    }
}
